import { render, staticRenderFns } from "./PedidoPagamento.vue?vue&type=template&id=1ecfc9c7"
import script from "./PedidoPagamento.vue?vue&type=script&lang=js"
export * from "./PedidoPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports